import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { FaUserDoctor } from "react-icons/fa6";
import { useAuthStore } from "../../auth/hooks";
import { SecretaryLayout } from "../Layout";
import { SecretaryProfile, SettingsSecretary } from "../components";

export const ProfilePage = () => {
  const { user } = useAuthStore();

  const [activeIndex, setActiveIndex] = useState(1);
  return (
    <SecretaryLayout>
      <div className="container-fluid">
        <div className="layout-specing">
          <div className="d-md-flex justify-content-between">
            <h5 className="mb-0">Perfil de administrador y configuración</h5>
            <nav
              aria-label="breadcrumb"
              className="d-inline-block mt-4 mt-sm-0"
            >
              <ul className="breadcrumb bg-transparent rounded mb-0 p-0">
                <li className="breadcrumb-item">
                  <Link to="/secretary/dashboard">Gosafe</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Perfil
                </li>
              </ul>
            </nav>
          </div>

          <div className="card rounded shadow overflow-hidden mt-4 border-0">
            <div className="p-5 bg-primary bg-gradient"></div>
            <div className="avatar-profile d-flex margin-nagative mt-n5 position-relative ps-3">
              <FaUserDoctor className="rounded-circle shadow-md avatar avatar-medium bg-light text-secondary p-2" />
              <div className="mt-4 ms-3 pt-3">
                <h5 className="mt-3 mb-1">
                  {user.firstName} {user.lastName}
                </h5>
                <p className="text-muted mb-0">{user.ipsName}</p>
              </div>
            </div>

            <div className="row">
              <div className="col-12 mt-4">
                <div className="card border-0 rounded-0 p-4">
                  <ul className="nav nav-pills nav-justified flex-column flex-sm-row rounded shadow overflow-hidden bg-light">
                    <li className="nav-item">
                      <Link
                        className={`${
                          activeIndex === 1 ? "active" : ""
                        } nav-link rounded-0`}
                        to="#"
                        onClick={() => setActiveIndex(1)}
                      >
                        <div className="text-center pt-1 pb-1">
                          <h5 className="mb-0">Perfil</h5>
                        </div>
                      </Link>
                    </li>

                    <li className="nav-item">
                      <Link
                        className={`${
                          activeIndex === 2 ? "active" : ""
                        } nav-link rounded-0`}
                        to="#"
                        onClick={() => setActiveIndex(2)}
                      >
                        <div className="text-center pt-1 pb-1">
                          <h5 className="mb-0">Configuración</h5>
                        </div>
                      </Link>
                    </li>
                  </ul>

                  <div className="tab-content mt-4" id="pills-tabContent">
                    {activeIndex === 1 && <SecretaryProfile />}
                    {activeIndex === 2 && <SettingsSecretary />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SecretaryLayout>
  );
};
